import { forwardRef, useImperativeHandle, useRef } from "react";
import { useZendeskChat } from "./useZendeskChat";

interface ZendeskChatProps {
  className?: string;
}

export interface ZendeskChatRef {
  openChat: () => void;
}

export const ZendeskChat = forwardRef<ZendeskChatRef, ZendeskChatProps>(
  ({ className }, ref) => {
    const { showLoader, isEnabled, openChat } = useZendeskChat();
    const divRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(
      ref,
      () => ({
        openChat
      }),
      [openChat]
    );

    if (!showLoader || !isEnabled) return null;

    return (
      <div
        ref={divRef}
        className={`fixed right-4 bottom-4 z-50 animate-bounce ${className || ""}`}
      >
        <div className="animate-pulse">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary text-primary shadow-neutral-400/50 shadow-lg">
            <button
              type="button"
              className="flex h-12 w-12 items-center justify-center text-white transition-colors hover:text-blue-100"
              aria-label="Loading chat support"
              disabled
            >
              <div className="relative">
                {/* Chat bubble icon */}
                <svg
                  className="h-6 w-6"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                  <path
                    d="M10,18 L6,22 L6,18 L10,18 Z M17,6 C19.7614237,6 22,8.23857625 22,11 C22,13.7614237 19.7614237,16 17,16 L17,16 L7,16 C4.23857625,16 2,13.7614237 2,11 C2,8.23857625 4.23857625,6 7,6 L7,6 Z"
                    transform="translate(12.000000, 14.000000) scale(-1, 1) translate(-12.000000, -14.000000)"
                    fill="currentColor"
                  />
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    );
  }
);

ZendeskChat.displayName = "ZendeskChat";
